var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({
    whiteSpace: 'no-wrap',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  })},[_c('button',{staticClass:"button is-info is-light is-small is-outline is-rounded",on:{"click":function($event){return _vm.loadUpdateUnitGroup(_vm.unitGroupID)}}},[_vm._v(" Edit")]),_vm._v("  "),_c('button',{staticClass:"button is-info is-light is-small is-outline is-rounded",on:{"click":function($event){return _vm.confirmDeleteUnitGroup(_vm.unitGroupID)}}},[_vm._v(" Delete ")])])}
var staticRenderFns = []

export { render, staticRenderFns }